export default "__VITE_ASSET__BbYCLaQh__"